import { ColumnSettings } from 'ui-components'

export function getEnabledColumnIdsFromStore<K extends string>(
  tableStoreId: string,
  filterFn: (value: unknown) => value is K,
): K[] {
  const storeKey = `ui-enabled-columns-${tableStoreId}`
  try {
    const items = JSON.parse(
      localStorage.getItem(storeKey) || '[]',
    ) as unknown[]
    return items.filter(filterFn)
  } catch (error) {
    return []
  }
}

export function setUserColumnsFromStoreFactory<
  T extends ColumnSettings<any, any, any, any>,
>(tableStoreId: string): (columnSettings: T) => void {
  const storeKey = `gws-ui-enabled-columns-${tableStoreId}`

  return (columnSettings) => {
    localStorage.setItem(
      storeKey,
      JSON.stringify(columnSettings.enabledColumnIds),
    )
  }
}
